const en = {
  public: {
    noauth: 'Please connect wallet first',
    login: 'Connect wallet',
    logout: 'Logout',
    confirm: 'Confirm',
    cancel: 'Cancel',
    loading: 'Loading...',
    noData: 'No Data',
    copy: 'Copy',
    balance: 'Balance',
    max: 'MAX',
    amount: 'Amount',
    from: 'From',
    to: 'To',
    price: 'Price',
    fee: 'Fee',
    slippage: 'Slippage Tolerance',
    multipath: 'Multi-path',
  },
  home: {
    home1: 'Decentralized Trading\non EOS Blockchain',
    home2: 'Experience lightning-fast swaps with the lowest fees.\nTotoro Swap brings DeFi trading to everyone.',
    home3: 'Ultra-Low Trading Fees',
    home4: 'Trade with fees as low as 0.3%. Our efficient AMM protocol ensures you get the best rates with minimal slippage on every swap.',
    home5: 'Multi-Wallet Support',
    home6: 'Connect with Anchor, TokenPocket, MetaMask, Scatter, and more. Trade seamlessly with your favorite EOS wallet.',
    home7: 'Create\nAccount',
    home8: 'Connect\nWallet',
    home9: 'Start\nTrading',
    home10: 'Totoro Swap is a decentralized exchange on EOS.',
    home11: 'Low Fees',
    home12: 'Trading fees as low as 0.2%.',
    home13: 'Support multiple wallets.',
    card1Title: 'Swap Trading',
    card1Desc: 'Instant token swaps with best-in-class routing and minimal slippage.',
    card2Title: 'Liquidity Pool',
    card2Desc: 'Earn trading fees by providing liquidity to pools with transparent APY.',
    card3Title: 'Lending Market',
    card3Desc: 'Borrow and lend assets with competitive rates and flexible terms.',
  },
  nav: {
    home: 'Home',
    trade: 'Trade',
    swap: 'Swap',
    liquidity: 'Liquidity',
    lend: 'Lend',
    market: 'Market',
    assets: 'Assets',
    mining: 'Mining',
    tradeMining: 'Trade Mining',
    liquidityMining: 'Liquidity Mining',
    lendMining: 'Lend Mining',
    vault: 'Vault',
    tools: 'Tools',
    createAccount: 'Create Account',
  },
  swap: {
    swap: 'Swap',
    pool: 'Pool',
    swapRecord: 'Swap Records',
    liquidityRecord: 'Liquidity Records',
    addLiquidity: 'Add Liquidity',
    removeLiquidity: 'Remove Liquidity',
    createMarket: 'Create Market',
    selectToken: 'Select a token',
    enterAmount: 'Enter an amount',
    insufficientBalance: 'Insufficient balance',
    priceImpact: 'Price Impact',
    minimumReceived: 'Minimum Received',
    route: 'Route',
    success: 'Transaction successful',
    loadMore: 'Load More',
    myLiquidity: 'My Liquidity',
    liquidityRatio: 'Liquidity Ratio',
    currentLiquidity: 'Current Liquidity',
    costBasis: 'Cost Basis',
    profit: 'Profit',
    poolReserves: 'Liquidity',
    availableCertificate: 'Available Certificate',
    withdrawAssets: 'Withdraw Assets',
    addLiquiditySuccess: 'Liquidity added successfully',
    removeLiquiditySuccess: 'Liquidity removed successfully',
    createMarketSuccess: 'Market created successfully',
    sameTokenError: 'Cannot select the same token',
    pairExistsError: 'This pair already exists',
    tokenNotFound: 'Token not found',
    tokenName: 'Token Name',
    enterTokenName: 'Enter token symbol',
    enterContractAddress: 'Enter contract account',
    tokenInfoEmpty: 'Token info cannot be empty',
    noPairFound: 'No pair found',
    noPool: 'No liquidity pool yet',
    add: 'Add',
    remove: 'Remove',
    certificate: 'Certificate',
  },
  lend: {
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    borrow: 'Borrow',
    repay: 'Repay',
    totalDeposit: 'Total Deposits',
    totalBorrow: 'Total Borrows',
    depositApy: 'Deposit APY',
    borrowApy: 'Borrow APY',
    walletBalance: 'Wallet Balance',
    myDeposit: 'My Deposits',
    myBorrow: 'My Borrows',
  },
  mining: {
    totalReward: 'Total Rewards',
    tvl: 'TVL',
    dailyEmission: 'Daily Emission',
    earned: 'Earned',
    stake: 'Stake',
    unstake: 'Unstake',
    claim: 'Claim',
    live: 'Live',
    finished: 'Finished',
    stakedOnly: 'Staked Only',
  },
  vault: {
    overview: 'Overview',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    totalValue: 'Total Value',
    apy: 'APY',
  },
  tools: {
    createAccount: 'Create EOS Account',
    accountName: 'Account Name',
    accountNameTip: 'Must be 12 characters (a-z, 1-5, .)',
    create: 'Create',
    remaining: 'Remaining',
    createTipTitle: 'Instructions',
    createTip1: 'Please keep your private key safe! If the private key is lost, the account will be lost!',
    createTip2: 'The registration fee is charged by the system, this service is a public service, no pumping',
    createTip3: 'If you want to self-register, directly send more than 0.06EOS to the smart contract "signup.free", memo format: [12-character name]-[public key]',
    createTip4: 'eg: itlnmuw2ywh-EOS4wXEq8fXfg4uvi344Fvq6x1REimGDF56dDoPiFcZ9qpRtPyahY',
    createTip5: 'More than part of the EOS will be automatically transferred to your new account. After registration, you can import the wallet for use. If you use it on a computer, it is recommended that you use the <a href="https://metahub.cash" target="_blank">Metahub wallet</a> with the best experience, download link: <a href="https://metahub.cash" target="_blank">https://metahub.cash</a>',
    createTip6: '<span style="color:#4ea95c">Free Account Creation</span> service provided by <a href="https://metahub.cash" target="_blank">Metahub</a>, limited per hour, first-come, first-served',
  },
  error: {
    canceled: 'Transaction canceled',
    error3080001: 'CPU resource exceeded',
    error3080002: 'NET resource exceeded',
    error3080004: 'Deadline exceeded',
    error3040005: 'Transaction expired',
    error3090003: 'Unsatisfied authorization',
  },
  toastTip: {
    loginSuccess: 'Wallet connected',
    logoutSuccess: 'Logout successful',
    copySuccess: 'Copied successfully',
    copyFail: 'Copy failed',
  },
  about: {
    title: 'About Totoro',
    copyright: 'Totoro Swap',
    github: 'GitHub',
    audit: 'Audit Report',
  },
  settings: {
    title: 'Settings',
    slippage: 'Slippage Tolerance',
    custom: 'Custom',
    multipath: 'Multi-path Routing',
    rpcNode: 'RPC Node',
    language: 'Language',
  },
  login: {
    title: 'Connect Wallet',
    web: 'Web Wallets',
    mobile: 'Mobile Wallets',
  },
} as const

export default en
